export const MARKETPLACE_CART_TRUST_ITEMS = [
  {
    id: "secure",
    title: "Secure Payments",
    description: "100% secure checkout",
    icon: "secure",
  },
  {
    id: "trade",
    title: "Trade Protection",
    description: "Buyer protection on all orders",
    icon: "trade",
  },
  {
    id: "returns",
    title: "Easy Returns",
    description: "Hassle free returns",
    icon: "returns",
  },
  {
    id: "delivery",
    title: "On-time Delivery",
    description: "Reliable & on-time",
    icon: "delivery",
  },
];

export const EMPTY_MARKETPLACE_CART = {
  totalItems: 0,
  freeShippingThreshold: 0,
  platformFee: 0,
  discount: 0,
  estimatedDelivery: "—",
  suppliers: [],
  frequentlyBoughtTogether: [],
  summary: {
    itemUnits: 0,
    lineCount: 0,
    subtotal: 0,
    gst: 0,
    shipping: 0,
    platformFee: 0,
    discount: 0,
    grandTotal: 0,
    freeShippingGap: 0,
  },
};
